import { CrystalImageDTO } from 'business/models/Models';
import CrystalService from 'business/services/CrystalService';
import { useWindowSize } from 'CustomHooks/useWindowSize';
import React, { useEffect, useState } from 'react';
import { Image, Layer, Stage } from 'react-konva';
import { GetBlankImageBase64 } from 'utils/Global';

interface CrystalImageProps {
  crystalId: number;
}

const CrystalImage = ({ crystalId }: CrystalImageProps) => {
  const [image, setImage] = useState<HTMLImageElement>();
  const [stage, setStage] = useState({
    width: undefined,
    height: undefined,
  });
  const [crystalImage, setCrystalImage] = useState<CrystalImageDTO>();
  const windowSize = useWindowSize();

  const hRatio = stage?.width / image?.width;
  const vRatio = stage?.height / image?.height;
  const ratio = Math.min(hRatio, vRatio);
  const scaledImageWidth = image?.width * ratio;
  const scaledImageHeight = image?.height * ratio;
  const centerShiftX = (stage?.width - scaledImageWidth) / 2;
  const centerShiftY = (stage?.height - scaledImageHeight) / 2;

  const getImageDivDimensions = () => {
    const container = document.querySelector<HTMLElement>('#crsytalimage-imagediv');
    return { w: container?.offsetWidth, h: container?.offsetHeight };
  };

  const paintImage = () => {
    const img = new window.Image();
    img.src = crystalImage?.image ?? GetBlankImageBase64();
    img.onload = () => {
      setImage(img);
    };
  };

  useEffect(() => {
    if (crystalId) {
      const crystalService = new CrystalService();
      const fetchImage = async () => {
        return await crystalService.getCrystalImage(crystalId);
      };
      fetchImage().then((data) => {
        setCrystalImage(data);
      });
    }
  }, [crystalId]);

  useEffect(() => {
    paintImage();
  }, [crystalImage]);

  useEffect(() => {
    setStage(() => ({
      width: getImageDivDimensions().w,
      height: getImageDivDimensions().h,
    }));
    paintImage();
  }, [windowSize]);

  return (
    <>
      <div className="h-full w-full" id="crsytalimage-imagediv">
        <Stage id="crsytalimage-stage" width={stage?.width} height={stage?.height}>
          <Layer id="crsytalimage-layer">
            <Image
              id="crsytalimage-image"
              image={image}
              x={centerShiftX}
              y={centerShiftY}
              width={scaledImageWidth}
              height={scaledImageHeight}
            />
          </Layer>
        </Stage>
      </div>
    </>
  );
};

export default CrystalImage;
